function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import dayjs from 'dayjs';
import { BaseAnalyticsService } from 'decap-cms-lib-analytics';
export class SimpleAnalytics extends BaseAnalyticsService {
  constructor({
    config
  }) {
    super(config);
    _defineProperty(this, "siteId", void 0);
    _defineProperty(this, "apiKey", void 0);
    _defineProperty(this, "apiEndpoint", void 0);
    _defineProperty(this, "isPublic", void 0);
    this.siteId = config.site_id;
    this.apiKey = config.api_key;
    this.apiEndpoint = config.api_endpoint || `https://simpleanalytics.com/${this.siteId}.json`;
    this.isPublic = config.is_public || false;
    return this;
  }
  static parseDateRange(period) {
    const end = dayjs().format('YYYY-MM-DD');
    let start = dayjs().subtract(1, 'week').format('YYYY-MM-DD');
    let interval = 'day';
    switch (period) {
      case 'today':
        start = dayjs().format('YYYY-MM-DD');
        interval = 'hour';
        break;
      case 'last24Hours':
        start = dayjs().subtract(1, 'day').format('YYYY-MM-DD');
        interval = 'hour';
        break;
      case 'thisWeek':
        start = dayjs().startOf('week').format('YYYY-MM-DD');
        break;
      case 'last7Days':
        start = dayjs().subtract(7, 'day').format('YYYY-MM-DD');
        break;
      case 'thisMonth':
        start = dayjs().startOf('month').format('YYYY-MM-DD');
        break;
      case 'last30Days':
        start = dayjs().subtract(30, 'day').format('YYYY-MM-DD');
        break;
      case 'thisYear':
        start = dayjs().startOf('year').format('YYYY-MM-DD');
        interval = 'month';
        break;
      case 'allTime':
        start = dayjs('2021-01-01').format('YYYY-MM-DD');
        interval = 'month';
        break;
    }
    return {
      start,
      end,
      interval
    };
  }
  parseMetrics(data) {
    return data.histogram.map(item => ({
      date: item.date,
      visitors: item.visitors
    }));
  }
  async getMetrics(period) {
    const headers = {
      'Content-Type': 'application/json'
    };
    if (!this.isPublic && this.apiKey) {
      headers['Api-Key'] = this.apiKey;
    }
    const {
      start,
      end,
      interval
    } = SimpleAnalytics.parseDateRange(period);
    const params = new URLSearchParams({
      version: '5',
      info: 'false',
      fields: 'histogram',
      start,
      end,
      interval
    });
    const url = new URL(this.apiEndpoint);
    url.search = params.toString();
    const response = await fetch(url, {
      headers
    });
    if (!response.ok) {
      throw new Error(`Failed to fetch data: ${response.statusText}`);
    }
    const data = await response.json();
    return {
      metrics: this.parseMetrics(data),
      interval
    };
  }
}